import { render } from "./ExamReportDetail.vue?vue&type=template&id=1ab39f93&scoped=true"
import script from "./ExamReportDetail.vue?vue&type=script&lang=js"
export * from "./ExamReportDetail.vue?vue&type=script&lang=js"

import "./ExamReportDetail.vue?vue&type=style&index=0&id=1ab39f93&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab39f93"]])

export default __exports__